import { uniCall } from '../../utils';
/**
 * 使用客户端提供的 API (`setTitle`) 设置导航栏标题
 * @param title 要设置的标题
 * @deprecated 建议统一使用 `setDocumentTitle` 设置标题
 */

export function setNavigatorTitle(title) {
  if (title === void 0) {
    title = '';
  }

  try {
    var params = JSON.stringify({
      title: title
    });
    uniCall({
      api: 'setTitle',
      param: params
    });
  } catch (err) {
    document.title = title;
  }
}